var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-profile-pic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-profile-pic:not(.animated) .animable {opacity: 0;}svg#freepik_stories-profile-pic.animated #freepik--Character--inject-37 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-37",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "elppi2divmqsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "el47tw4gvezy5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "elwq50klz4whc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "elybtq1j2pm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "elunftolbc007",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "ela598l2tqwbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "elhx3z5uzmb8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el2pekeo9bo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "el3x7m3tvcrdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.87,
    y: 72.01,
    width: 273.57,
    height: 159.59,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.655px 151.805px"
    },
    id: "el9cu8trlz9tu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.36,
    y: 80.45,
    width: 258.58,
    height: 142.71,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "218.65px 151.805px"
    },
    id: "elt0y6clquswa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.26 223.16 111.85 223.16 132.01 80.45 153.42 80.45 133.26 223.16",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "132.635px 151.805px"
    },
    id: "elt64mnllwzsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.16 223.16 164.75 223.16 184.91 80.45 206.32 80.45 186.16 223.16",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "185.535px 151.805px"
    },
    id: "el7x30cy1nh92",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.95 223.16 298.25 223.16 318.4 80.45 329.11 80.45 308.95 223.16",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.68px 151.805px"
    },
    id: "ell4txls8z1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.99 223.16 194.28 223.16 214.44 80.45 225.15 80.45 204.99 223.16",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "209.715px 151.805px"
    },
    id: "elaq8yyuuazzv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.66,
    y: 80.45,
    width: 10.09,
    height: 142.71,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "152.705px 151.805px"
    },
    id: "elcsnkgaszwro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4zl2qwcrxlr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.75,
    y: 80.45,
    width: 2.25,
    height: 142.71,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "158.875px 151.805px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elk1s21uwse4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltfpmxyfjo3i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.44,
    y: 72.01,
    width: 1.61,
    height: 159.59,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "356.245px 151.805px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elyn2pcczba9q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.4,289.51c-2.66-29.48-4.52-77.31-3.08-93.31a2,2,0,0,1,.75-1.39h0a1.84,1.84,0,0,1,2.93,1.65c-.25,7.93-.54,27.74,1,61.93.78,17,1.92,28.66,1.14,31.12Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "410.11px 241.978px"
    },
    id: "elnxks9e5pzdh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,228.48c-6.37-8-19.38-13.66-32.64-13.64-5.21,0,15.84,9.29,24.59,19.53,6.8,7.95,14.46,21.33,17.07,28.76C409.52,247.5,408.56,236.46,402.19,228.48Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "389.971px 238.985px"
    },
    id: "elph02rovrl6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.51,228.4c6.31-8.78,20.86-15.54,36.61-16.3,6.18-.3-17.34,10.72-26.12,22-6.82,8.78-13.81,23.31-15.73,31.28C409.81,248.85,409.21,237.18,415.51,228.4Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "431.573px 238.737px"
    },
    id: "el2v0ylt7vv2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,241.3c-6.37-8-19.38-13.66-32.64-13.63-5.21,0,15.84,9.29,24.59,19.52,6.8,8,14.46,21.34,17.07,28.76C409.52,260.33,408.56,249.29,402.19,241.3Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "389.971px 251.81px"
    },
    id: "elbaetg9m1nf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.51,241.94c6.31-8.78,20.86-15.54,36.61-16.3,6.18-.3-17.34,10.72-26.12,22-6.82,8.78-13.81,23.31-15.73,31.28C409.81,262.39,409.21,250.72,415.51,241.94Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "431.573px 252.277px"
    },
    id: "elhjljgwp293",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.34,198.31c-4.17-5.93-13.11-10.56-22.43-11.19-3.67-.25,10.78,7.31,16.54,14.94,4.47,5.93,9.35,15.72,10.9,21.07C407.76,212.06,407.51,204.24,403.34,198.31Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "394.335px 205.122px"
    },
    id: "el1kr6e34josw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.64,200.82c4.44-6.19,14.7-10.95,25.8-11.48,4.36-.22-12.22,7.55-18.41,15.51-4.8,6.18-9.73,16.43-11.09,22C407.62,215.24,407.2,207,411.64,200.82Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "422.959px 208.093px"
    },
    id: "els6yzyogin4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,206c-5.4-6.76-16.42-11.57-27.64-11.54-4.41,0,13.41,7.86,20.82,16.53,5.75,6.73,12.25,18.06,14.45,24.35C408.11,222.12,407.3,212.77,401.91,206Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "391.559px 214.9px"
    },
    id: "elzypgcvl7iqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.87,209.61c5.34-7.44,17.66-13.16,31-13.8,5.23-.26-14.69,9.08-22.12,18.64-5.77,7.43-11.7,19.73-13.32,26.48C408,226.93,407.53,217,412.87,209.61Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "426.461px 218.367px"
    },
    id: "elkyiptw6iejb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,215.39c-5.82-7.3-17.71-12.48-29.82-12.46-4.76,0,14.47,8.49,22.46,17.84,6.21,7.27,13.21,19.49,15.6,26.27C408.25,232.77,407.37,222.68,401.55,215.39Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "390.386px 224.985px"
    },
    id: "elbx7pfyexa6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.71,219.38c5.92-8.25,19.61-14.6,34.42-15.32,5.81-.28-16.31,10.08-24.56,20.7-6.41,8.25-13,21.91-14.8,29.4C408.34,238.62,407.78,227.64,413.71,219.38Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "428.807px 229.107px"
    },
    id: "el3z587nej54j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,284.53l-1,8.28a3.5,3.5,0,0,1-3.5,3.3H399.11a3.51,3.51,0,0,1-3.5-3.3l-1-8.28a3.51,3.51,0,0,1,3.5-3.71h26.68A3.5,3.5,0,0,1,428.31,284.53Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "411.46px 288.465px"
    },
    id: "elitrq9yevwsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.79,286.28H393.15a1.06,1.06,0,0,1-1-.94l-.87-7.88a1.05,1.05,0,0,1,1-1.17h38.38a1.05,1.05,0,0,1,1,1.17l-.87,7.88A1.05,1.05,0,0,1,429.79,286.28Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "411.47px 281.285px"
    },
    id: "el2q30a2ze3cq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2q1a7f3qlu6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.7,
    y: 296.11,
    width: 15.91,
    height: 86.29,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "244.655px 339.255px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elf174wd2i0pf"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "241.47 382.4 236.7 382.4 236.7 365.89 246.47 365.89 241.47 382.4",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "241.585px 374.145px"
    },
    id: "eln6fxnntvho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf3rlt8bhqot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.94,
    y: 296.11,
    width: 15.91,
    height: 86.29,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "442.895px 339.255px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elk83zwysgqxn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6kzqe7szt8h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.7,
    y: 296.11,
    width: 202.4,
    height: 76.15,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "337.9px 334.185px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el1x3nsfbieroi"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "434.33 382.4 439.1 382.4 439.1 365.89 429.33 365.89 434.33 382.4",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "434.215px 374.145px"
    },
    id: "elljp3tx7octl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljm0iuk4ddp"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.4,
    y: 301.47,
    width: 195,
    height: 30.47,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "337.9px 316.705px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "els14xjdi6yil"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269,310.94H403.62c4.65,0,9.1-3.76,12.3-10.4H256.68C259.88,307.18,264.33,310.94,269,310.94Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "336.3px 305.74px"
    },
    id: "el9u22lrdu8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqxvysu8axcf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.4,
    y: 336.87,
    width: 195,
    height: 30.47,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "337.9px 352.105px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el7ocgjfzwcq4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269,346.34H403.62c4.65,0,9.1-3.76,12.3-10.4H256.68C259.88,342.58,264.33,346.34,269,346.34Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "336.3px 341.14px"
    },
    id: "el0vjgwfxj80w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.66,275.89s.87,20.22,34.22,20.22,34.23-20.22,34.23-20.22Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "318.885px 286px"
    },
    id: "el3ye3v8e9ej9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.66,265.39s.87,20.22,34.22,20.22,34.23-20.22,34.23-20.22Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "318.885px 275.5px"
    },
    id: "elpwtdnf65p1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.11,
    y: 316.78,
    width: 33.28,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "174.75px 319.63px"
    },
    id: "elceu3r089vwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf0sqlwvgrqg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.34,
    y: 251.33,
    width: 6.14,
    height: 131.07,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "98.41px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elwosxscuip0a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpk0s4l67kw"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 316.78,
    width: 84.05,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "116.085px 319.63px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eln4u12mji01a"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 158.11,
    y: 347.95,
    width: 33.28,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "174.75px 350.8px"
    },
    id: "elu061biebe8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu3wubtiptms"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 347.95,
    width: 84.05,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "116.085px 350.8px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elkxg8pjx8mbd"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 158.11,
    y: 254.45,
    width: 33.28,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "174.75px 257.3px"
    },
    id: "elzjzllg3rdu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo5sxpu8ip4m"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 254.45,
    width: 84.05,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "116.085px 257.3px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elhiyl5iskcok"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 158.11,
    y: 285.61,
    width: 33.28,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "174.75px 288.46px"
    },
    id: "elz31iylstp0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3er6w5ku0tf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 285.61,
    width: 84.05,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "116.085px 288.46px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eleu0o39v92l8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli26x0cu7vh9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.39,
    y: 251.33,
    width: 6.14,
    height: 131.07,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "182.46px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elolx8xbukizh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elryhpp7y9ls"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.97,
    y: 251.33,
    width: 6.14,
    height: 131.07,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "155.04px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elh0933grp55c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6tjw0ucxoyb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 251.33,
    width: 6.14,
    height: 131.07,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "77.13px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el2fprrt7fk7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-37",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-37",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-37",
    className: "animable animator-active",
    style: {
      transformOrigin: "287.581px 253.435px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.41,140.39c1.05-3.26,10.49-11.46,22.15-7.32s9,20.45,7.74,24.59-8.73,16.62-17.41,14S194.5,150.1,208.41,140.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.369px 151.973px"
    },
    id: "els00vannvg1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,153.11c.77-2.41,7.73-8.45,16.32-5.4s6.63,15.07,5.7,18.12-6.43,12.24-12.83,10.32S223.67,160.26,233.92,153.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.466px 161.64px"
    },
    id: "eltknogx6419b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,143.51l-5.93,8.05S235.44,144.93,244.3,143.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.103px 147.535px"
    },
    id: "elzporwpor1tr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19,166.68c-1.62-1.56-9.64-3.38-15.11,2.64S214.21,184,216.23,186s10.21,6.92,14.44,2.72S239.26,168,228.19,166.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.074px 177.758px"
    },
    id: "elvu3hud624i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,196l-.22.57-.2.49c-.14.32-.27.64-.41.94-.28.62-.58,1.2-.88,1.79-.61,1.17-1.24,2.31-1.91,3.43a59.11,59.11,0,0,1-4.48,6.36c-.79,1-1.66,2-2.5,3s-1.76,1.89-2.71,2.77a58.7,58.7,0,0,1-5.9,5c-.29.21-.39.33-1.09.79a6.62,6.62,0,0,1-2.28.9,6.2,6.2,0,0,1-2.75-.11,6.63,6.63,0,0,1-2.05-1,9.17,9.17,0,0,1-2.18-2.21,15.06,15.06,0,0,1-1.23-2,37.82,37.82,0,0,1-2.71-7.52,88.71,88.71,0,0,1-2.39-14.72l4.55-.81c1.38,4.51,2.86,9.08,4.55,13.35a36.4,36.4,0,0,0,2.82,5.83,8.64,8.64,0,0,0,.75,1c.22.24.44.39.39.31a.93.93,0,0,0-.42-.21,2,2,0,0,0-1-.06,2.3,2.3,0,0,0-.62.2c-.2.13.16-.16.34-.33a64.72,64.72,0,0,0,9.12-9.82,61.06,61.06,0,0,0,3.71-5.56q.85-1.42,1.62-2.88l.72-1.45.34-.71.27-.61Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "207.785px 207.437px"
    },
    id: "el0ypcqxf1oen",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,182.15c-7.83,3.57-10.86,13.51-11.13,14.06l9.71,17.65S233.26,207.17,234,201C234.7,195.79,230.38,179.8,225.23,182.15Z",
    style: {
      fill: "current",
      transformOrigin: "224.087px 197.888px"
    },
    id: "eleml5u6hzha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.68,194.71l2.46-7.42-9.32,2s-.21,6.44,2.78,8.77l1.59-.66A4.36,4.36,0,0,0,194.68,194.71Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "192.478px 192.675px"
    },
    id: "el7k1epvgr7vx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.84 179.35 188.19 182.12 187.82 189.27 197.14 187.28 194.84 179.35",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "192.48px 184.31px"
    },
    id: "el2sns76v2cg6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.78,120.25l-6.47-7.41-3,9s5.06,4.36,9.18.56Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "261.045px 118.397px"
    },
    id: "el8rkrwn63aff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.62 109.35 251.04 115.55 256.28 121.88 259.31 112.84 255.62 109.35",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "255.175px 115.615px"
    },
    id: "elhsg0mdiiesb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.72 387.72 339.14 393.74 320.62 381.44 327.2 375.42 345.72 387.72",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "333.17px 384.58px"
    },
    id: "elsnw7uwy4iv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.55 307.02 411.15 316.13 389.93 318.13 390.33 309.02 411.55 307.02",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "400.74px 312.575px"
    },
    id: "eli1r5t0lqtyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.93,316.53l-2.47-9.94a.71.71,0,0,1,.43-.85l7.59-3.09a1.46,1.46,0,0,1,1.92,1c.8,3.48,1,5.2,2.1,9.57.67,2.69,2.54,8.54,3.47,12.25s-2.7,4.83-3.42,3.36c-3.21-6.56-6.16-9.14-8.7-11A2.46,2.46,0,0,1,408.93,316.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.278px 316.007px"
    },
    id: "elmg5997h299",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.12,393l4.45-9.86a.9.9,0,0,1,.95-.51l8.77,1.37a1.35,1.35,0,0,1,1,1.91c-1.62,3.42-2.58,5-4.53,9.35-1.21,2.66-4.85,11.48-6.51,15.16s-5.6,2.71-5.26,1.08c1.53-7.36,2-13.92,1-16.86A2.27,2.27,0,0,1,336.12,393Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "343.195px 397.786px"
    },
    id: "elsqcu43eg7hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm27nhgceqr9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.63 381.44 330.43 387.96 336.79 381.79 327.21 375.42 320.63 381.44",
    style: {
      opacity: 0.2,
      transformOrigin: "328.71px 381.69px"
    },
    className: "animable",
    id: "el9dh3bvtp43m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elurusw483gif"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.33 309.01 389.93 318.13 400.87 317.1 401.27 307.98 390.33 309.01",
    style: {
      opacity: 0.2,
      transformOrigin: "395.6px 313.055px"
    },
    className: "animable",
    id: "elubp8h1yy73b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.75,187s4.09,20.2,24.53,38c2.58,2.24,2.07,8,5.62,7.52,12.43-7.84,25.16-15.56,31.2-19.38.15-6.88-4.56-5.77-5.67-9.47-2.66-8.81-9.95-18.74-17.49-40.43a108.11,108.11,0,0,0-14.4,6.64,129.18,129.18,0,0,0-14.22,9A119.38,119.38,0,0,0,219.75,187Z",
    style: {
      fill: "current",
      transformOrigin: "250.427px 197.894px"
    },
    id: "el6gnxrz6ntd2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,154.75c2,5.14,6.39,14.08,11.52,15.11,0,0,3.1,14.82-3,23-9.59-1.59-11.21-14.07-11.21-14.07,4.33-4.44,1.81-8.14-1.32-11.13Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "236.149px 173.805px"
    },
    id: "elszh3pzktt2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,193.67a4,4,0,0,1-2.84-1.34c-1.86-1.91-1.22-4.82-.54-7.91s1.36-6.19,0-8.95a.28.28,0,1,1,.51-.25c1.47,2.93.73,6.33.07,9.32s-1.25,5.71.4,7.39a3.21,3.21,0,0,0,4.63.34c3.28-2.43,5.37-9.28,3-13.5-2.17-4,0-7.46,1-9.14a5.35,5.35,0,0,0,.48-.85.27.27,0,0,1,.21-.33.29.29,0,0,1,.34.23c.06.27-.14.6-.54,1.25-1.07,1.71-3.06,4.91-1,8.57,2.45,4.45.25,11.66-3.2,14.23A4.28,4.28,0,0,1,234.62,193.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "236.224px 181.057px"
    },
    id: "el0ggmu6teb9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmm2vul4rpdh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.38,160,228,167.7a17.79,17.79,0,0,1,2,2.25c1.77-1.51,3.6-5.11,2.52-7.29A9.84,9.84,0,0,0,230.38,160Z",
    style: {
      opacity: 0.2,
      transformOrigin: "230.421px 164.975px"
    },
    className: "animable",
    id: "el4c0syz5ugc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,144.4c2.77,8.62,4.13,12.2,1.57,18.18-3.85,9-15,10.51-20.33,2.9-4.76-6.85-8.49-19.79-1.56-26.35A12.34,12.34,0,0,1,231.57,144.4Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "220.966px 153.037px"
    },
    id: "elwud9cxib5ln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.71,142.29c.59,4.71,10.72,10.12,20.11,7.91,6.56-1.55,1.46-13.07-6.34-15.09S212.74,134.58,213.71,142.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.224px 142.502px"
    },
    id: "ela8f6j7mifrn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.05,142.26l-19.82,2.47S203.82,131.36,218.05,142.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.14px 141.356px"
    },
    id: "elyarvywu4ed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.79,142,200.66,149S202.12,136.3,216.79,142Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.725px 144.764px"
    },
    id: "el7tufw3em9q4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.13,142l-4.5,6.38S208.23,143.26,215.13,142Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.678px 145.19px"
    },
    id: "elqo474hyaxei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.59,142,201,138.14S209.45,129.11,217.59,142Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.295px 138.533px"
    },
    id: "el3p0tk0icvjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.89,142.38l-7.77-9.64S217,131.32,215.89,142.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.053px 137.53px"
    },
    id: "elmi1zhivom0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85,151.48a6.63,6.63,0,0,1-.65,5c-1.16,2-3.36,1.35-4.38-.59-.92-1.75-1.42-4.91.4-6.25A3,3,0,0,1,235.85,151.48Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "233.033px 153.406px"
    },
    id: "el9pgievbod5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61,233.24s4,81.24,19.32,104.42c16,24.12,55.3,49.91,55.3,49.91l11-9.32s-37-35-45.18-55.35c-11.32-28.08-13.43-106.73-13.43-106.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.42px 301.87px"
    },
    id: "elt1y9j4unqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.24 377.47 324.94 388.77 318.72 385.39 331.74 372.26 337.24 377.47",
    style: {
      fill: "current",
      transformOrigin: "327.98px 380.515px"
    },
    id: "el8chcym3x1kl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2hex2t4hqos"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.87,234.89c-.13,9.59,5.35,22.51,12.34,30.77-.76-7.62-1.38-15-1.88-21.63C275.82,240.13,272.19,236.72,268.87,234.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "275.039px 250.275px"
    },
    className: "animable",
    id: "eloxi8ekfhaq9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,228s37.89,50.08,61.37,77c19,21.71,77.7,14.42,77.7,14.42l0-12.56s-42.14,1-55.16-13.64c-41.64-47-42-72.1-60.85-79.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.405px 267.038px"
    },
    id: "el73revfb6ppt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.21 304.78 398.24 322.1 390.06 324.38 390.44 304.86 398.21 304.78",
    style: {
      fill: "current",
      transformOrigin: "394.15px 314.58px"
    },
    id: "elltozexx7m6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.22,211.34l3.18,1.91c.25.14.13.53-.23.76l-32.83,20.73c-.28.18-.61.19-.74,0l-2-2.63c-.14-.18,0-.5.31-.69l31.7-20A.68.68,0,0,1,281.22,211.34Z",
    style: {
      fill: "current",
      transformOrigin: "266.539px 223.09px"
    },
    id: "elwg5969cfe1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltmn6oib2tdf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.22,211.34l3.18,1.91c.25.14.13.53-.23.76l-32.83,20.73c-.28.18-.61.19-.74,0l-2-2.63c-.14-.18,0-.5.31-.69l31.7-20A.68.68,0,0,1,281.22,211.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "266.539px 223.09px"
    },
    className: "animable",
    id: "elan7nxj5lqi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.2,217.57l.85-.54c.17-.1.24-.27.16-.37l-2.69-3.39c-.08-.1-.29-.09-.45,0l-.85.54c-.17.11-.25.28-.17.37l2.7,3.39A.36.36,0,0,0,279.2,217.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "278.131px 215.424px"
    },
    id: "el4z7xzncf2h6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.92,233.54l.84-.54c.17-.1.25-.27.17-.37l-2.7-3.39c-.08-.1-.28-.09-.45,0l-.85.54c-.17.11-.24.28-.16.38l2.69,3.38A.37.37,0,0,0,253.92,233.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.849px 231.394px"
    },
    id: "elj6iemv0gei7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.56,225.56l.85-.54c.17-.11.24-.28.16-.38l-2.7-3.38c-.07-.1-.28-.1-.45,0l-.85.54c-.17.1-.24.27-.16.37l2.7,3.39C266.19,225.67,266.39,225.66,266.56,225.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.49px 223.412px"
    },
    id: "elrgpkb21yxxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.73,151.74c.27.68.12,1.38-.32,1.56s-1-.24-1.3-.93-.12-1.38.33-1.55S219.46,151.06,219.73,151.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.914px 152.062px"
    },
    id: "elxx13cyrd7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,154.77c.27.68.12,1.38-.33,1.55s-1-.24-1.29-.92-.12-1.38.33-1.56S211.72,154.08,212,154.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.186px 155.078px"
    },
    id: "el0stxdxqz0z5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,153.8l-1.83.17S210.42,154.93,210.91,153.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.995px 154.075px"
    },
    id: "el1u3p0opvwan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,155.14a19.49,19.49,0,0,1-.74,5.33,3.15,3.15,0,0,0,2.62-.5Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "215.07px 157.853px"
    },
    id: "elf07e3yn9tvt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.82,161.74a.22.22,0,0,1-.25-.13.21.21,0,0,1,.12-.28,5.88,5.88,0,0,0,3.6-3.86.21.21,0,0,1,.25-.16.21.21,0,0,1,.17.25,6.16,6.16,0,0,1-3.86,4.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.634px 159.525px"
    },
    id: "el18f60om7cql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,149a.45.45,0,0,1-.3,0,3.45,3.45,0,0,0-3.12-.05.43.43,0,0,1-.59-.16.44.44,0,0,1,.15-.59,4.3,4.3,0,0,1,3.94,0,.44.44,0,0,1,.2.58A.43.43,0,0,1,220.08,149Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.207px 148.374px"
    },
    id: "elwhar3mfrjz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,152.59a.45.45,0,0,1-.2,0,.43.43,0,0,1-.33-.51A4.26,4.26,0,0,1,209,149a.42.42,0,0,1,.55.25.41.41,0,0,1-.25.55,3.43,3.43,0,0,0-1.9,2.47A.45.45,0,0,1,207,152.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.022px 150.786px"
    },
    id: "el0hlkwsodcdht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,162l.54-.26.72-.36c.49-.25,1-.52,1.48-.81,1-.59,2-1.23,2.92-1.92A45.83,45.83,0,0,0,273.1,154a66.51,66.51,0,0,0,4.92-5.39l1.13-1.46.56-.73.07-.09,0,0,0,0s0-.06.06-.09a1.82,1.82,0,0,0,.15-1.3,9.23,9.23,0,0,0-.91-2.6,26.22,26.22,0,0,0-1.76-2.91,54.53,54.53,0,0,0-4.68-5.72,137.05,137.05,0,0,0-11.17-10.62l2.64-3.79a92.51,92.51,0,0,1,13.23,9.55,53.68,53.68,0,0,1,5.95,6A28.39,28.39,0,0,1,286,138.5a16.77,16.77,0,0,1,2,4.73,11.14,11.14,0,0,1,.31,3.08,9.62,9.62,0,0,1-.79,3.38,7.4,7.4,0,0,1-.39.8l-.22.38-.19.29-.57.89L285,153.82a61.72,61.72,0,0,1-5.38,6.64,54.86,54.86,0,0,1-6.49,5.75,40.52,40.52,0,0,1-3.69,2.43c-.65.38-1.31.74-2,1.09l-1.07.5c-.4.17-.69.3-1.28.51Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "274.894px 145.02px"
    },
    id: "elfmxuz31nbuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,167.34c4.4-4.83,18.57-9.37,18.57-9.37l4.55,23.16s-4.91,4.89-10.86,3.21C255.56,182.91,242.09,174.22,248.36,167.34Z",
    style: {
      fill: "current",
      transformOrigin: "259.104px 171.331px"
    },
    id: "elmk194ti50ze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,321.27a1.36,1.36,0,0,1-.81.33.74.74,0,0,1-.69-.27c-.72-.91.35-4,.47-4.38a.21.21,0,0,1,.19-.15.24.24,0,0,1,.21.12c.55,1.08,1.4,3,.85,4.06A1.23,1.23,0,0,1,411,321.27Zm-.79-3.68c-.39,1.26-.75,3-.37,3.47a.31.31,0,0,0,.31.11.78.78,0,0,0,.69-.4C411.11,320.22,410.87,319.05,410.18,317.59Z",
    style: {
      fill: "current",
      transformOrigin: "410.325px 319.204px"
    },
    id: "elr9uvtk0grdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.74,319.49a2.15,2.15,0,0,1-1.21.68.75.75,0,0,1-.76-.56,1.09,1.09,0,0,1,.06-1c.61-1.17,3.15-1.81,3.26-1.84a.21.21,0,0,1,.21.06.22.22,0,0,1,.05.21A6.49,6.49,0,0,1,408.74,319.49Zm-1.24-1a1.31,1.31,0,0,0-.29.36.69.69,0,0,0,0,.61c.1.26.23.28.34.28.63,0,1.82-1.39,2.28-2.4A6.42,6.42,0,0,0,407.5,318.49Z",
    style: {
      fill: "current",
      transformOrigin: "408.517px 318.467px"
    },
    id: "elwbjp3ctc15i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78,398.09a3.54,3.54,0,0,1-1.33,1.72,1.34,1.34,0,0,1-1.17.08.65.65,0,0,1-.43-.49c-.2-1.17,2.84-3.84,3.45-4.36a.23.23,0,0,1,.25,0,.21.21,0,0,1,.1.23A14,14,0,0,1,335.78,398.09Zm-2.41.81a.72.72,0,0,0-.09.42c0,.06,0,.12.15.16a.89.89,0,0,0,.81-.05c.7-.38,1.37-1.71,1.84-3.63A13.71,13.71,0,0,0,333.37,398.9Z",
    style: {
      fill: "current",
      transformOrigin: "334.748px 397.495px"
    },
    id: "elwyzlm72xuul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,395.29l-.05.07c-1,.9-3.77,2.34-4.64,1.79-.19-.12-.38-.37-.22-.91.65-2.05,4.59-1.29,4.76-1.25a.2.2,0,0,1,.16.15A.26.26,0,0,1,336.64,395.29Zm-4.44.95a.5.5,0,0,0-.05.13q-.11.33,0,.42c.5.31,2.63-.6,3.76-1.45C335,395.21,332.73,395.06,332.2,396.24Z",
    style: {
      fill: "current",
      transformOrigin: "334.163px 396.046px"
    },
    id: "elk24tnxa8bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.65,150.78l-1.83.17S218.17,151.9,218.65,150.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.735px 151.053px"
    },
    id: "el5eawgx7p3mh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.36,
    y: 90.63,
    width: 166.39,
    height: 325.61,
    rx: 27.85,
    style: {
      fill: "current",
      transformOrigin: "239.555px 253.435px"
    },
    id: "el03u6qpuq5dcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8baqikoz1en"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.36,
    y: 90.63,
    width: 166.39,
    height: 325.61,
    rx: 27.85,
    style: {
      opacity: 0.2,
      transformOrigin: "239.555px 253.435px"
    },
    className: "animable",
    id: "elnqmu3vafdwq"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 289.67,
    y: 143.13,
    width: 35.27,
    height: 43.4,
    rx: 7.7,
    style: {
      fill: "current",
      transformOrigin: "307.305px 164.83px"
    },
    id: "el54a3zrdtjbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elry2dkcr93k9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.67,
    y: 143.13,
    width: 35.27,
    height: 43.4,
    rx: 7.7,
    style: {
      opacity: 0.2,
      transformOrigin: "307.305px 164.83px"
    },
    className: "animable",
    id: "elyx2r4it41za"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 153.04,
    y: 143.13,
    width: 35.27,
    height: 57.3,
    rx: 7.7,
    style: {
      fill: "current",
      transformOrigin: "170.675px 171.78px"
    },
    id: "elwga7x0chaaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elijcxfbng2i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.04,
    y: 143.13,
    width: 35.27,
    height: 57.3,
    rx: 7.7,
    style: {
      opacity: 0.2,
      transformOrigin: "170.675px 171.78px"
    },
    className: "animable",
    id: "eltdre24zj8z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 289.67,
    y: 189.66,
    width: 35.27,
    height: 43.4,
    rx: 7.7,
    style: {
      fill: "current",
      transformOrigin: "307.305px 211.36px"
    },
    id: "el7o97h53jvhs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljo6dm0mylz"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.67,
    y: 189.66,
    width: 35.27,
    height: 43.4,
    rx: 7.7,
    style: {
      opacity: 0.2,
      transformOrigin: "307.305px 211.36px"
    },
    className: "animable",
    id: "el95axfnps0xo"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 154.79,
    y: 90.63,
    width: 166.39,
    height: 325.61,
    rx: 27.85,
    style: {
      fill: "current",
      transformOrigin: "237.985px 253.435px"
    },
    id: "el3p0c5jv2pnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elblhshw4wllg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 173.56,
    width: 318.96,
    height: 159.75,
    rx: 24.53,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "237.98px 253.435px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elj335cp1apvh"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 290.39,
    y: 102.64,
    width: 14.57,
    height: 8.26,
    rx: 1.69,
    style: {
      fill: "current",
      transformOrigin: "297.675px 106.77px"
    },
    id: "el7ppzilnydog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9f6lto1hqzl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 102.64,
    width: 18.8,
    height: 8.26,
    rx: 1.91,
    style: {
      fill: "current",
      opacity: 0.2,
      transformOrigin: "180.07px 106.77px"
    },
    className: "animable",
    id: "elwc1l56j0s08"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 288.6,
    y: 104.05,
    width: 3,
    height: 5.44,
    rx: 0.62,
    style: {
      fill: "current",
      transformOrigin: "290.1px 106.77px"
    },
    id: "el20626p96991",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.56,
    y: 104.05,
    width: 3,
    height: 5.44,
    rx: 0.62,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "302.06px 106.77px"
    },
    id: "elqd5wevr2vjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.77,
    y: 104.05,
    width: 3,
    height: 5.44,
    rx: 0.62,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "298.27px 106.77px"
    },
    id: "elineafsmla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsilvm2pl0ki"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.37,119.69H300.6a4.36,4.36,0,0,1,4.36,4.36V276.81a4.36,4.36,0,0,1-4.36,4.36H175.37a4.37,4.37,0,0,1-4.37-4.37V124.06a4.36,4.36,0,0,1,4.36-4.36Z",
    style: {
      fill: "current",
      opacity: 0.2,
      transformOrigin: "237.98px 200.43px"
    },
    className: "animable",
    id: "elw9rphwj39p9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "290.266px 261.151px"
    },
    id: "elgkntlqoj2a9",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elva4o66teybj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271,137.18c3.48-4.46,8-7.64,11.4-7.64a3.53,3.53,0,0,1,3.71,3.29,8,8,0,0,1,4.43-1.86c2.3,0,3.12,2.15,2.31,5.18a10,10,0,0,1,3.85-1.16c2.34-.13,3.66,1.1,3.79,3.11a3.78,3.78,0,0,1,1.65-.58c1.36-.08,1.71,1.17.81,2.78l-.18.3H265.59C266.13,139,269.35,137.25,271,137.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "284.519px 135.067px"
    },
    className: "animable",
    id: "elbi25b0yrsxj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljeg8km32j9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.21,221.46c8.74-11.19,20.17-19.16,28.63-19.16,5.31,0,8.46,3.14,9.3,8.24,3.9-2.91,7.84-4.65,11.12-4.65,5.77,0,7.85,5.39,5.79,13a25.34,25.34,0,0,1,9.67-2.9c5.9-.34,9.21,2.76,9.53,7.8a9.54,9.54,0,0,1,4.14-1.46c3.4-.19,4.3,2.94,2,7-.14.26-.29.5-.44.75H186.55C187.92,226.08,196,221.66,200.21,221.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "234.107px 216.19px"
    },
    className: "animable",
    id: "els54z131e2qd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm6uauik4ib"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.73,181.61a7.86,7.86,0,0,1,.93-.07c4.55-4.41,9.15-7.23,12.41-7.23,2.36,0,3.64,1.47,3.88,4,8.5-8.57,17.27-14.14,23.38-14.14,4.93,0,7.23,3.62,6.95,9.53,4.21-3.36,8.22-5.37,11.27-5.37,5.37,0,6.2,6.22,2.73,15h0a23.61,23.61,0,0,1,9.57-3.36c5.54-.4,8,3.18,7.25,9a9.15,9.15,0,0,1,4.14-1.68c3-.21,3.37,3,.92,7.31H241.1C245.82,188.05,254,182.35,259.73,181.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "292.936px 179.385px"
    },
    className: "animable",
    id: "ela6pzt84jfu9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsn4weyn1n2m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.33,155a3,3,0,0,1,.5,0c2.42-2.35,4.87-3.85,6.61-3.85,1.26,0,1.94.78,2.07,2.11,4.53-4.57,9.2-7.54,12.46-7.54,2.63,0,3.85,1.93,3.7,5.08,2.25-1.79,4.38-2.86,6-2.86,2.86,0,3.3,3.31,1.45,8h0a12.66,12.66,0,0,1,5.1-1.8c2.95-.21,4.25,1.7,3.86,4.81a5,5,0,0,1,2.21-.9c1.62-.11,1.8,1.6.49,3.9H158.41C160.92,158.44,165.25,155.4,168.33,155Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "186.029px 153.835px"
    },
    className: "animable",
    id: "elzpfb1grlb8c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,140.39c1.05-3.26,10.49-11.46,22.15-7.32s9,20.45,7.74,24.59-8.73,16.62-17.41,14S194.5,150.1,208.41,140.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.369px 151.973px"
    },
    id: "elve7zzgm4q08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,153.11c.77-2.41,7.73-8.45,16.32-5.4s6.63,15.07,5.7,18.12-6.43,12.24-12.83,10.32S223.67,160.26,233.92,153.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.466px 161.64px"
    },
    id: "ellrlnx9kgqwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,143.51l-5.93,8.05S235.44,144.93,244.3,143.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.103px 147.535px"
    },
    id: "elsqwh1x99h9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19,166.68c-1.62-1.56-9.64-3.38-15.11,2.64S214.21,184,216.23,186s10.21,6.92,14.44,2.72S239.26,168,228.19,166.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.074px 177.758px"
    },
    id: "el3pq4bwa2mnd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,196l-.22.57-.2.49c-.14.32-.27.64-.41.94-.28.62-.58,1.2-.88,1.79-.61,1.17-1.24,2.31-1.91,3.43a59.11,59.11,0,0,1-4.48,6.36c-.79,1-1.66,2-2.5,3s-1.76,1.89-2.71,2.77a58.7,58.7,0,0,1-5.9,5c-.29.21-.39.33-1.09.79a6.62,6.62,0,0,1-2.28.9,6.2,6.2,0,0,1-2.75-.11,6.63,6.63,0,0,1-2.05-1,9.17,9.17,0,0,1-2.18-2.21,15.06,15.06,0,0,1-1.23-2,37.82,37.82,0,0,1-2.71-7.52,88.71,88.71,0,0,1-2.39-14.72l4.55-.81c1.38,4.51,2.86,9.08,4.55,13.35a36.4,36.4,0,0,0,2.82,5.83,8.64,8.64,0,0,0,.75,1c.22.24.44.39.39.31a.93.93,0,0,0-.42-.21,2,2,0,0,0-1-.06,2.3,2.3,0,0,0-.62.2c-.2.13.16-.16.34-.33a64.72,64.72,0,0,0,9.12-9.82,61.06,61.06,0,0,0,3.71-5.56q.85-1.42,1.62-2.88l.72-1.45.34-.71.27-.61Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "207.785px 207.437px"
    },
    id: "elxeg7i2s3vx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,182.15c-7.83,3.57-10.86,13.51-11.13,14.06l9.71,17.65S233.26,207.17,234,201C234.7,195.79,230.38,179.8,225.23,182.15Z",
    style: {
      fill: "current",
      transformOrigin: "224.087px 197.888px"
    },
    id: "eljkc28sbg7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.68,194.71l2.46-7.42-9.32,2s-.21,6.44,2.78,8.77l1.59-.66A4.36,4.36,0,0,0,194.68,194.71Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "192.478px 192.675px"
    },
    id: "el7796fdmksi4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.84 179.35 188.19 182.12 187.82 189.27 197.14 187.28 194.84 179.35",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "192.48px 184.31px"
    },
    id: "elvit61x1chm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.78,120.25l-6.47-7.41-3,9s5.06,4.36,9.18.56Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "261.045px 118.397px"
    },
    id: "elx19108y8z37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.62 109.35 251.04 115.55 256.28 121.88 259.31 112.84 255.62 109.35",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "255.175px 115.615px"
    },
    id: "els4lialte3jk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.72 387.72 339.14 393.74 320.62 381.44 327.2 375.42 345.72 387.72",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "333.17px 384.58px"
    },
    id: "el4grl1lhzrfv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.55 307.02 411.15 316.13 389.93 318.13 390.33 309.02 411.55 307.02",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "400.74px 312.575px"
    },
    id: "el4uv6sr7c7e6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.93,316.53l-2.47-9.94a.71.71,0,0,1,.43-.85l7.59-3.09a1.46,1.46,0,0,1,1.92,1c.8,3.48,1,5.2,2.1,9.57.67,2.69,2.54,8.54,3.47,12.25s-2.7,4.83-3.42,3.36c-3.21-6.56-6.16-9.14-8.7-11A2.46,2.46,0,0,1,408.93,316.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.278px 316.007px"
    },
    id: "elhg4x7sekwhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.12,393l4.45-9.86a.9.9,0,0,1,.95-.51l8.77,1.37a1.35,1.35,0,0,1,1,1.91c-1.62,3.42-2.58,5-4.53,9.35-1.21,2.66-4.85,11.48-6.51,15.16s-5.6,2.71-5.26,1.08c1.53-7.36,2-13.92,1-16.86A2.27,2.27,0,0,1,336.12,393Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "343.195px 397.786px"
    },
    id: "elz7o2ikv85u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el02njzgyionhh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.63 381.44 330.43 387.96 336.79 381.79 327.21 375.42 320.63 381.44",
    style: {
      opacity: 0.2,
      transformOrigin: "328.71px 381.69px"
    },
    className: "animable",
    id: "elb1bw6oxplhn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8reddqlntll"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.33 309.01 389.93 318.13 400.87 317.1 401.27 307.98 390.33 309.01",
    style: {
      opacity: 0.2,
      transformOrigin: "395.6px 313.055px"
    },
    className: "animable",
    id: "el2ke7s6cbmw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.75,187s4.09,20.2,24.53,38c2.58,2.24,2.07,8,5.62,7.52,12.43-7.84,25.16-15.56,31.2-19.38.15-6.88-4.56-5.77-5.67-9.47-2.66-8.81-9.95-18.74-17.49-40.43a108.11,108.11,0,0,0-14.4,6.64,129.18,129.18,0,0,0-14.22,9A119.38,119.38,0,0,0,219.75,187Z",
    style: {
      fill: "current",
      transformOrigin: "250.427px 197.894px"
    },
    id: "ellf3cnpv0cgq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,154.75c2,5.14,6.39,14.08,11.52,15.11,0,0,3.1,14.82-3,23-9.59-1.59-11.21-14.07-11.21-14.07,4.33-4.44,1.81-8.14-1.32-11.13Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "236.149px 173.805px"
    },
    id: "el7w643p55avw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,193.67a4,4,0,0,1-2.84-1.34c-1.86-1.91-1.22-4.82-.54-7.91s1.36-6.19,0-8.95a.28.28,0,1,1,.51-.25c1.47,2.93.73,6.33.07,9.32s-1.25,5.71.4,7.39a3.21,3.21,0,0,0,4.63.34c3.28-2.43,5.37-9.28,3-13.5-2.17-4,0-7.46,1-9.14a5.35,5.35,0,0,0,.48-.85.27.27,0,0,1,.21-.33.29.29,0,0,1,.34.23c.06.27-.14.6-.54,1.25-1.07,1.71-3.06,4.91-1,8.57,2.45,4.45.25,11.66-3.2,14.23A4.28,4.28,0,0,1,234.62,193.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "236.224px 181.057px"
    },
    id: "elow6vlnm0bgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5xf4af3mlmd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.38,160,228,167.7a17.79,17.79,0,0,1,2,2.25c1.77-1.51,3.6-5.11,2.52-7.29A9.84,9.84,0,0,0,230.38,160Z",
    style: {
      opacity: 0.2,
      transformOrigin: "230.421px 164.975px"
    },
    className: "animable",
    id: "ela0s4l3620at"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,144.4c2.77,8.62,4.13,12.2,1.57,18.18-3.85,9-15,10.51-20.33,2.9-4.76-6.85-8.49-19.79-1.56-26.35A12.34,12.34,0,0,1,231.57,144.4Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "220.966px 153.037px"
    },
    id: "elp3nebmojeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.71,142.29c.59,4.71,10.72,10.12,20.11,7.91,6.56-1.55,1.46-13.07-6.34-15.09S212.74,134.58,213.71,142.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.224px 142.502px"
    },
    id: "elo4riqkmvo6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.05,142.26l-19.82,2.47S203.82,131.36,218.05,142.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.14px 141.356px"
    },
    id: "elqtfl4qgfwgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.79,142,200.66,149S202.12,136.3,216.79,142Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.725px 144.764px"
    },
    id: "elcd6l6spwq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.13,142l-4.5,6.38S208.23,143.26,215.13,142Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.678px 145.19px"
    },
    id: "elm9fss1kc0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.59,142,201,138.14S209.45,129.11,217.59,142Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.295px 138.533px"
    },
    id: "el0bgdi44qnmtg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.89,142.38l-7.77-9.64S217,131.32,215.89,142.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.053px 137.53px"
    },
    id: "elgvx771789qq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85,151.48a6.63,6.63,0,0,1-.65,5c-1.16,2-3.36,1.35-4.38-.59-.92-1.75-1.42-4.91.4-6.25A3,3,0,0,1,235.85,151.48Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "233.033px 153.406px"
    },
    id: "elu5atqz9y0wq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61,233.24s4,81.24,19.32,104.42c16,24.12,55.3,49.91,55.3,49.91l11-9.32s-37-35-45.18-55.35c-11.32-28.08-13.43-106.73-13.43-106.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.42px 301.87px"
    },
    id: "els7j0pg9ow7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.24 377.47 324.94 388.77 318.72 385.39 331.74 372.26 337.24 377.47",
    style: {
      fill: "current",
      transformOrigin: "327.98px 380.515px"
    },
    id: "elljfbyur41s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloroirscvzl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.87,234.89c-.13,9.59,5.35,22.51,12.34,30.77-.76-7.62-1.38-15-1.88-21.63C275.82,240.13,272.19,236.72,268.87,234.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "275.039px 250.275px"
    },
    className: "animable",
    id: "elsyc1q9ly22l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,228s37.89,50.08,61.37,77c19,21.71,77.7,14.42,77.7,14.42l0-12.56s-42.14,1-55.16-13.64c-41.64-47-42-72.1-60.85-79.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.405px 267.038px"
    },
    id: "el4e5u15w37rn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.21 304.78 398.24 322.1 390.06 324.38 390.44 304.86 398.21 304.78",
    style: {
      fill: "current",
      transformOrigin: "394.15px 314.58px"
    },
    id: "elxcyxjl5rtjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.22,211.34l3.18,1.91c.25.14.13.53-.23.76l-32.83,20.73c-.28.18-.61.19-.74,0l-2-2.63c-.14-.18,0-.5.31-.69l31.7-20A.68.68,0,0,1,281.22,211.34Z",
    style: {
      fill: "current",
      transformOrigin: "266.539px 223.09px"
    },
    id: "ellwbmzw9rzpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhroq1zkhlld"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.22,211.34l3.18,1.91c.25.14.13.53-.23.76l-32.83,20.73c-.28.18-.61.19-.74,0l-2-2.63c-.14-.18,0-.5.31-.69l31.7-20A.68.68,0,0,1,281.22,211.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "266.539px 223.09px"
    },
    className: "animable",
    id: "elpfcy20fpum"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.2,217.57l.85-.54c.17-.1.24-.27.16-.37l-2.69-3.39c-.08-.1-.29-.09-.45,0l-.85.54c-.17.11-.25.28-.17.37l2.7,3.39A.36.36,0,0,0,279.2,217.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "278.131px 215.424px"
    },
    id: "elf5oqcuzhq1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.92,233.54l.84-.54c.17-.1.25-.27.17-.37l-2.7-3.39c-.08-.1-.28-.09-.45,0l-.85.54c-.17.11-.24.28-.16.38l2.69,3.38A.37.37,0,0,0,253.92,233.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.849px 231.394px"
    },
    id: "elzdgv91ixvms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.56,225.56l.85-.54c.17-.11.24-.28.16-.38l-2.7-3.38c-.07-.1-.28-.1-.45,0l-.85.54c-.17.1-.24.27-.16.37l2.7,3.39C266.19,225.67,266.39,225.66,266.56,225.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.49px 223.412px"
    },
    id: "elrydzqfya5kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.73,151.74c.27.68.12,1.38-.32,1.56s-1-.24-1.3-.93-.12-1.38.33-1.55S219.46,151.06,219.73,151.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.914px 152.062px"
    },
    id: "elwswbimmas6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,154.77c.27.68.12,1.38-.33,1.55s-1-.24-1.29-.92-.12-1.38.33-1.56S211.72,154.08,212,154.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.186px 155.078px"
    },
    id: "elf4028ipu07c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,153.8l-1.83.17S210.42,154.93,210.91,153.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.995px 154.075px"
    },
    id: "elxpi33h06dl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,155.14a19.49,19.49,0,0,1-.74,5.33,3.15,3.15,0,0,0,2.62-.5Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "215.07px 157.853px"
    },
    id: "elqar6y5wwm2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.82,161.74a.22.22,0,0,1-.25-.13.21.21,0,0,1,.12-.28,5.88,5.88,0,0,0,3.6-3.86.21.21,0,0,1,.25-.16.21.21,0,0,1,.17.25,6.16,6.16,0,0,1-3.86,4.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.634px 159.525px"
    },
    id: "eln872hb0cwya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,149a.45.45,0,0,1-.3,0,3.45,3.45,0,0,0-3.12-.05.43.43,0,0,1-.59-.16.44.44,0,0,1,.15-.59,4.3,4.3,0,0,1,3.94,0,.44.44,0,0,1,.2.58A.43.43,0,0,1,220.08,149Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.207px 148.374px"
    },
    id: "eloyjqdbvqqdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,152.59a.45.45,0,0,1-.2,0,.43.43,0,0,1-.33-.51A4.26,4.26,0,0,1,209,149a.42.42,0,0,1,.55.25.41.41,0,0,1-.25.55,3.43,3.43,0,0,0-1.9,2.47A.45.45,0,0,1,207,152.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.022px 150.786px"
    },
    id: "el2ofnkf8mr6y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3,162.25l.66-.41.74-.47c.51-.32,1-.65,1.52-1,1-.68,2-1.42,3-2.15a66,66,0,0,0,5.7-4.74c1.82-1.67,3.57-3.42,5.23-5.26l1.93-2.21c.1-.12.22-.43.12-1.17a9.37,9.37,0,0,0-.94-2.59,25.62,25.62,0,0,0-1.79-2.9,57.35,57.35,0,0,0-4.73-5.7,144.16,144.16,0,0,0-11.2-10.59l2.64-3.79a94.4,94.4,0,0,1,13.23,9.51,54.14,54.14,0,0,1,6,5.95,29.16,29.16,0,0,1,2.66,3.64,17.06,17.06,0,0,1,2.06,4.7,10.61,10.61,0,0,1,.33,3.11,9.42,9.42,0,0,1-.83,3.46,9.59,9.59,0,0,1-.92,1.55l-.64.87-1.25,1.7a74,74,0,0,1-5.56,6.31,77.86,77.86,0,0,1-6.3,5.59c-1.11.86-2.25,1.69-3.43,2.48-.59.4-1.19.79-1.8,1.18l-.94.56c-.33.19-.61.35-1.05.58Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "274.885px 144.865px"
    },
    id: "elm1dtczd7b9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,167.34c4.4-4.83,18.57-9.37,18.57-9.37l4.55,23.16s-4.91,4.89-10.86,3.21C255.56,182.91,242.09,174.22,248.36,167.34Z",
    style: {
      fill: "current",
      transformOrigin: "259.104px 171.331px"
    },
    id: "el69hkj2mb9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,321.27a1.36,1.36,0,0,1-.81.33.74.74,0,0,1-.69-.27c-.72-.91.35-4,.47-4.38a.21.21,0,0,1,.19-.15.24.24,0,0,1,.21.12c.55,1.08,1.4,3,.85,4.06A1.23,1.23,0,0,1,411,321.27Zm-.79-3.68c-.39,1.26-.75,3-.37,3.47a.31.31,0,0,0,.31.11.78.78,0,0,0,.69-.4C411.11,320.22,410.87,319.05,410.18,317.59Z",
    style: {
      fill: "current",
      transformOrigin: "410.325px 319.204px"
    },
    id: "elutx8afehcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.74,319.49a2.15,2.15,0,0,1-1.21.68.75.75,0,0,1-.76-.56,1.09,1.09,0,0,1,.06-1c.61-1.17,3.15-1.81,3.26-1.84a.21.21,0,0,1,.21.06.22.22,0,0,1,.05.21A6.49,6.49,0,0,1,408.74,319.49Zm-1.24-1a1.31,1.31,0,0,0-.29.36.69.69,0,0,0,0,.61c.1.26.23.28.34.28.63,0,1.82-1.39,2.28-2.4A6.42,6.42,0,0,0,407.5,318.49Z",
    style: {
      fill: "current",
      transformOrigin: "408.517px 318.467px"
    },
    id: "elfe2lf99ow6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78,398.09a3.54,3.54,0,0,1-1.33,1.72,1.34,1.34,0,0,1-1.17.08.65.65,0,0,1-.43-.49c-.2-1.17,2.84-3.84,3.45-4.36a.23.23,0,0,1,.25,0,.21.21,0,0,1,.1.23A14,14,0,0,1,335.78,398.09Zm-2.41.81a.72.72,0,0,0-.09.42c0,.06,0,.12.15.16a.89.89,0,0,0,.81-.05c.7-.38,1.37-1.71,1.84-3.63A13.71,13.71,0,0,0,333.37,398.9Z",
    style: {
      fill: "current",
      transformOrigin: "334.748px 397.495px"
    },
    id: "elfhimphx5kbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,395.29l-.05.07c-1,.9-3.77,2.34-4.64,1.79-.19-.12-.38-.37-.22-.91.65-2.05,4.59-1.29,4.76-1.25a.2.2,0,0,1,.16.15A.26.26,0,0,1,336.64,395.29Zm-4.44.95a.5.5,0,0,0-.05.13q-.11.33,0,.42c.5.31,2.63-.6,3.76-1.45C335,395.21,332.73,395.06,332.2,396.24Z",
    style: {
      fill: "current",
      transformOrigin: "334.163px 396.046px"
    },
    id: "elno6xeo4tha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.65,150.78l-1.83.17S218.17,151.9,218.65,150.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.735px 151.053px"
    },
    id: "el6m9zoggpwkh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 292.1,
    width: 87.68,
    height: 8.65,
    style: {
      fill: "current",
      transformOrigin: "214.84px 296.425px"
    },
    id: "ely6ixo8bnvf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 308.61,
    width: 58.13,
    height: 8.65,
    style: {
      fill: "current",
      transformOrigin: "200.065px 312.935px"
    },
    id: "elclxczpzhtpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 377.82,
    width: 32.15,
    height: 3.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.675px 379.695px"
    },
    id: "el5cdi3yngs7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.01,
    y: 384.96,
    width: 21.32,
    height: 3.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.67px 386.835px"
    },
    id: "eldt6sz834rnu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.17,
    y: 377.82,
    width: 32.15,
    height: 3.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "237.245px 379.695px"
    },
    id: "elij3ggwdmbqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.59,
    y: 384.96,
    width: 21.32,
    height: 3.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "237.25px 386.835px"
    },
    id: "elzh27qnfch7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.22,
    y: 377.82,
    width: 32.15,
    height: 3.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "286.295px 379.695px"
    },
    id: "eljgb291fj2an",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.64,
    y: 384.96,
    width: 21.32,
    height: 3.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "286.3px 386.835px"
    },
    id: "elbokf6miohl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.47,93.16a7.89,7.89,0,0,0,7.86,7.86h49.31a7.89,7.89,0,0,0,7.86-7.86Z",
    style: {
      fill: "current",
      transformOrigin: "237.985px 97.09px"
    },
    id: "elcasn5oudcoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5mfcpxkeg0n"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 189.67,
    cy: 351.29,
    r: 18.67,
    style: {
      fill: "current",
      transformOrigin: "189.67px 351.29px",
      transform: "rotate(-76.72deg)"
    },
    className: "animable",
    id: "elj03a479x9sp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.28,348.57c-4.53-1.38-7.35-6.32-7.35-6.32s-1.43-.08-1.5,1.22a6.39,6.39,0,0,0,1.88,4.71l-2.18-.13a7.22,7.22,0,0,0-2.31.25l-.72.2a2.38,2.38,0,0,0-1.69,2.87l1,4.24a5.29,5.29,0,0,0,5.89,4c2.22-.33,5.67-.83,6.27-.94h0l1.58-.13.54-9.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "186.015px 350.956px"
    },
    id: "el02bz3iyehhy2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.41,
    y: 347.26,
    width: 7.83,
    height: 12.53,
    rx: 0.86,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.325px 353.525px"
    },
    id: "elywxxolx6pmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el76s0f6wlslo"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 286.3,
    cy: 351.29,
    r: 18.67,
    style: {
      fill: "current",
      transformOrigin: "286.3px 351.29px",
      transform: "rotate(-76.72deg)"
    },
    className: "animable",
    id: "ela27j68qu0i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.3,341.55a9.2,9.2,0,0,0-2.1,18.15l2.1,2.67,2.1-2.67h0a9.2,9.2,0,0,0-2.1-18.15Zm0,13a3.83,3.83,0,1,1,3.83-3.83A3.83,3.83,0,0,1,286.3,354.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "286.3px 351.96px"
    },
    id: "el8c0kbuejmh5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0xhtde240gsq"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237.98,
    cy: 351.29,
    r: 18.67,
    style: {
      fill: "current",
      transformOrigin: "237.98px 351.29px",
      transform: "rotate(-45deg)"
    },
    className: "animable",
    id: "elt80nkrn4q0r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.31,347a.44.44,0,0,0-.25-.47,7.46,7.46,0,0,0-3-.6,6.73,6.73,0,0,0-6.72,6.72c0,2.48,1.66,3.78,3.3,3.78a4.35,4.35,0,0,0,3.53-1.7,2.45,2.45,0,0,0,.55,1,2.37,2.37,0,0,0,1.73.7c2.56,0,5.16-2.32,5.16-6.75a7.78,7.78,0,0,0-8.16-8.1c-5.76,0-10.11,4.57-10.11,10.62,0,5.05,3.56,8.71,8.47,8.71a10,10,0,0,0,4.92-1.11.43.43,0,0,0,.2-.53l-.42-1.14a.4.4,0,0,0-.26-.25.39.39,0,0,0-.35,0,7.87,7.87,0,0,1-3.8.88c-3.82,0-6.39-2.71-6.39-6.74,0-4.85,3.17-8.38,7.53-8.38,3.7,0,6,2.37,6,6.18a5.51,5.51,0,0,1-1.28,3.89,1.72,1.72,0,0,1-1.14.54.43.43,0,0,1-.34-.15c-.15-.19-.36-.74,0-2.32Zm-3.59,1.2a4.41,4.41,0,0,1,.83.08l-.48,2.6c-.27,1.51-1.55,3.25-2.81,3.25s-1.32-1-1.32-1.58C234.94,350.16,236.67,348.17,238.72,348.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "237.478px 351.243px"
    },
    id: "eljdpae49afo",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.37,119.69H300.6a4.36,4.36,0,0,1,4.36,4.36V276.81a4.36,4.36,0,0,1-4.36,4.36H175.37a4.37,4.37,0,0,1-4.37-4.37V124.06a4.36,4.36,0,0,1,4.36-4.36Z",
    style: {
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthUser);
export default __webpack_public_path__ + "static/media/authUser.f7643790.svg";
export { ForwardRef as ReactComponent };